import React, { Dispatch } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import type { ApprovalStatus, DynamicLinkId, ApprovalResult } from '../generated-types';
import { AnalyticsEvents } from '../services/analytics';

export enum Actions {
    SIGN_START,
    SIGN_SUCCESS,
    SIGN_ERROR,
    CLEAR_ERROR,
    RESET,
    CANCEL,
    CANCEL_SIGNING,
    COMPLETE_SIGNING,
    UPDATE_STATUS,
    PAYMENT_CHECKED,
}

export type Action =
    | { type: Actions.SIGN_START }
    | { type: Actions.SIGN_SUCCESS; result: ApprovalResult }
    | { type: Actions.SIGN_ERROR; error: RequestExceptionWithResponse }
    | { type: Actions.CLEAR_ERROR }
    | { type: Actions.RESET }
    | { type: Actions.CANCEL }
    | { type: Actions.COMPLETE_SIGNING; status: ApprovalStatus }
    | { type: Actions.UPDATE_STATUS; status: ApprovalStatus }
    | { type: Actions.CANCEL_SIGNING }
    | { type: Actions.PAYMENT_CHECKED; status: ApprovalStatus };

export interface SigningFlowState {
    signingOperationPending: boolean;
    showSigningFlow: boolean;
    signingStatus?: ApprovalStatus;
    signingError?: RequestExceptionWithResponse;
    redirectUri?: string;
    dynamicLinkId?: DynamicLinkId;
    bankIDOnly: boolean;
}

export interface SigningAction {
    children: React.ReactNode;
    analyticsCategory: string;
    analyticsEvent?: AnalyticsEvents;
}

export interface SigningTypes {
    state: SigningFlowState;
    dispatch: Dispatch<Action>;
    analyticsCategory: string;
    analyticsEvent: AnalyticsEvents;
}
